import React from "react";

const ConcentrationMetricsTable = ({
  concentrationtableData,
  setConcentrationTableData,
}) => {
  const handleChange = (index, field, value) => {
    const updated = [...concentrationtableData];
    updated[index][field] = value;
    setConcentrationTableData(updated);
  };

  return (
    <div
      style={{
        overflowX: "auto",
        marginTop: "20px",
        borderRadius: "8px",
        overflow: "hidden",
        border: "1px solid #000",
      }}
    >
      <table
        style={{
          width: "100%",
          borderCollapse: "collapse",
        }}
      >
        <thead>
          <tr style={{ backgroundColor: "#D3C9CE", fontWeight: "bold" }}>
            <th style={{ ...tableHeaderStyle, width: "17%" }}>Parameters</th>
            <th style={{ ...tableHeaderStyle, width: "26%" }}>Metrics</th>
            <th style={{ ...tableHeaderStyle, width: "28%" }}>
              Current Financial Year
            </th>
            <th style={{ ...tableHeaderStyle, width: "29%" }}>
              Previous Financial Year
            </th>
          </tr>
        </thead>
        <tbody>
          {concentrationtableData.map((row, index) => {
            const showCategory =
              index === 0 ||
              row.category !== concentrationtableData[index - 1].category;
            return (
              <tr key={index}>
                <td
                  style={{
                    ...tableCellStyle,
                    textAlign: "left",
                    fontSize: "15px",
                  }}
                >
                  {showCategory ? <strong>{row.category}</strong> : ""}
                </td>

                <td
                  style={{
                    ...tableCellStyle,
                    textAlign: "left",
                    fontSize: "15px",
                  }}
                >
                  <strong>{row.metric}</strong>
                </td>

                <td style={tableCellStyle}>
                  <textarea
                    placeholder="Provide Details"
                    value={row.current}
                    onChange={(e) =>
                      handleChange(index, "current", e.target.value)
                    }
                    style={textareaStyle}
                  />
                </td>
                <td style={tableCellStyle}>
                  <textarea
                    placeholder="Provide Details"
                    value={row.previous}
                    onChange={(e) =>
                      handleChange(index, "previous", e.target.value)
                    }
                    style={textareaStyle}
                  />
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};

// Styles
const tableHeaderStyle = {
  padding: "10px",
  border: "1px solid #ccc",
  textAlign: "center",
  fontSize: "14px",
};

const tableCellStyle = {
  padding: "10px",
  border: "1px solid #ccc",
  verticalAlign: "top",
  fontSize: "13px",
};

const textareaStyle = {
  width: "95%",
  minHeight: "70px",
  padding: "6px",
  borderRadius: "6px",
  border: "1px solid grey",
  fontSize: "13px",
  backgroundColor: "white",
  resize: "vertical",
  outline: "none",
};

export default ConcentrationMetricsTable;
